export class DateHelper {

  static addMonths(date: Date, months): Date {
    let m = null;
    if (date) {
      m = new Date(date);
    } else {
      m = new Date();
    }
    const n = m.getDate();
    m.setDate(1);
    m.setMonth(m.getMonth() + months);
    m.setDate(Math.min(n, DateHelper.getDaysInMonth(m.getFullYear(), m.getMonth())));
    return m;
  }

  static isLeapYear(year) {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
  };

  static getDaysInMonth(year, month) {
    return [31, (DateHelper.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
  };

  static getLastDayOfPreviousMonth(): Date {

    const today = new Date();
    today.setDate(1);
    today.setMonth(today.getMonth() - 1);

    return new Date(today.getFullYear(), today.getMonth() + 1, 0);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/helpers/date-helper.ts